import type { ComponentSchema } from "../../../../../schema-types";
import { SLIDE_SCHEMA, SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "hero",
  label: "Hero Section",
  description: "The main attention-grabbing section at the top of the page.",
  supportedPages: ["home", "categories", "about", "contact"],
  variants: [
    {
      id: "v1",
      label: "V1 — Fashion Full-Height Slider",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: SLIDE_SCHEMA },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: true },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5000 },
      ],
    },
    {
      id: "v2",
      label: "V2 — Electronics Two-Column Slider",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: SLIDE_SCHEMA },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: true },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5000 },
      ],
    },
    {
      id: "v3",
      label: "V3 — Beauty Gradient Hero",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: SLIDE_SCHEMA },
      ],
    },
    {
      id: "v4",
      label: "V4 — Jewelry Dark Elegant Hero",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: SLIDE_SCHEMA },
      ],
    },
    {
      id: "v5",
      label: "Display (black band, headline and card)",
      fields: [
        { key: "eyebrow", label: "Eyebrow", type: "localized-string", default: "Shoes for every day", help: "Small line with a rule, above the headline." },
        { key: "headline", label: "Headline", type: "localized-string", default: "Built to walk." },
        { key: "highlight", label: "Highlighted words", type: "localized-string", default: "Made to be worn.", help: "Shown in the accent colour on their own line under the headline." },
        { key: "text", label: "Paragraph", type: "localized-text", default: "Sneakers, runners and everyday shoes in EU sizes, picked and checked by people who wear them." },
        { key: "ctaText", label: "Button text", type: "localized-string", default: "Our story" },
        { key: "ctaLink", label: "Button link", type: "string", default: "/about" },
        { key: "linkText", label: "Second link text", type: "localized-string", default: "Shop the drop" },
        { key: "linkHref", label: "Second link", type: "string", default: "/shop" },
        { key: "cardWord", label: "Card word", type: "localized-string", default: "Local", help: "A short word in big letters on the dark card." },
        { key: "cardText", label: "Card line", type: "localized-text", default: "Cut, sewn and printed close to home, in small runs." },
        { key: "cardLabel", label: "Card corner label (left)", type: "localized-string", default: "Dhaka" },
        { key: "cardLabelEnd", label: "Card corner label (right)", type: "localized-string", default: "Since 2024" },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
